import { isEmpty } from 'lodash';
import { Dispatch } from 'redux';

import { ProductModel } from '../models/products.model';
import { DataSchemeList } from '../store/location';

export const wrap = (fn: <T>(arg: T) => Promise<T>, type = '') => {
    return function (dispatch: Dispatch) {
        return fn(dispatch).catch((error: string) => {
            try {
                const errorJson = JSON.parse(error) as Error;
                dispatch({ type, payload: errorJson });

                return error;
            } catch (e) {
                return e as string;
            }
        });
    };
};

export const getCordsMap = (data: DataSchemeList): DataSchemeList => {
    let cordsMap: any = null;

    const {
        data: { products, product },
    } = data;
    const firstProduct = (product ? product : products ? Object.values(products)[0] : {}) as ProductModel;

    if (firstProduct && firstProduct.latitude && firstProduct.longitude) {
        cordsMap = {
            lat: firstProduct.latitude as number,
            lng: firstProduct.longitude as number,
        };
    }

    if (
        firstProduct &&
        (!firstProduct.latitude || !firstProduct.longitude) &&
        (!isEmpty(firstProduct.subpoints) || !isEmpty(firstProduct.area))
    ) {
        const { subpoints, area } = firstProduct;
        let firstPoint: any[];
        if (subpoints) {
            if (subpoints[0]) {
                if (subpoints[0].x) {
                    //    For the specific subpoints format
                    firstPoint = [subpoints[0].x, subpoints[0].y];
                } else {
                    firstPoint = subpoints[0] as unknown as number[];
                }
            } else {
                firstPoint = area[0];
            }
        } else {
            firstPoint = area[0];
        }

        cordsMap = {
            lat: firstPoint[1],
            lng: firstPoint[0],
        };
    }

    return { ...data, centerCordsMap: cordsMap };
};
